import { render, staticRenderFns } from "./EmptyRouter.vue?vue&type=template&id=0c6bb2ec"
import script from "./EmptyRouter.vue?vue&type=script&lang=js"
export * from "./EmptyRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c6bb2ec')) {
      api.createRecord('0c6bb2ec', component.options)
    } else {
      api.reload('0c6bb2ec', component.options)
    }
    module.hot.accept("./EmptyRouter.vue?vue&type=template&id=0c6bb2ec", function () {
      api.rerender('0c6bb2ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/EmptyRouter.vue"
export default component.exports